import TextInfo from '../text/TextInfo';
import Video from './Video';
// import VideoGhosts from '../ghosts/VideoGhosts'; // For template when no video is available
import { useLanguage } from '../../context/LanguageContext';

function VideoInfo() {
  const { t } = useLanguage();

  return (
    <section className="px-8">
      <h2 className="font-bold sm:text-3xl text-2xl">
        <span className="text-blue">{t('watch')}</span> <span className="text-red">{t('our')}</span>{' '}
        <span className="text-green">{t('video')}</span>
        <span className="text-yellow">!</span>
      </h2>
      <br />
      <TextInfo
        hasTitle={false}
        title="Video Information"
        isContentText={true}
        content={t('videoInformationText')}
      />
      <br />
      <Video src={'https://youtu.be/y5PwoW6tydM'} />
    </section>
  );
}

export default VideoInfo;
